import React from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import {
  AddBillingInfoModal,
  BillingCard,
  BookingDetailTitle,
} from '@components';
import { generateShortId, showError, showSuccess } from '@utils';
import { subscriptionsServices, usersServices } from '@services';

import styles from './bookingPaymentBilling.style';

const BillingDetails = ({
  billingInfos = [],
  user,
  subscription,
  hideAddButton = false,
  onGetUser,
  onGetData,
  onSubmit,
}) => {
  const methods = useFormContext();
  const billingInfo = methods.watch('billingInfo');

  const handleSelect = async (data) => {
    try {
      methods.setValue('billingInfo', data);
      if (onSubmit) {
        await onSubmit();
      }
      showSuccess('Billing detail updated');
    } catch (error) {
      showError(error);
    }
  };

  const handleEdit = async (values, billingInfoItem) => {
    if (values?.contract === 'Ιδιώτης') {
      delete values.contract;
      delete values.companyName;
    } else {
      delete values.contract;
    }
    const data = billingInfos.map((item) => {
      if (item?.billingId === billingInfoItem?.billingId) {
        return { ...values, billingId: billingInfoItem?.billingId };
      }
      return item;
    });

    if (user) {
      await usersServices.editUserBillingInfo(user.id, {
        billingInfo: data,
      });
    }
    if (subscription) {
      await subscriptionsServices.editSubscriptionById(subscription.id, {
        billingInfo: data?.[0],
      });
    }
    await onGetData();

    if (onGetUser) {
      await onGetUser();
    }
  };

  return (
    <Box sx={styles.section}>
      <Box sx={styles.titleRow}>
        <BookingDetailTitle>Billing Details</BookingDetailTitle>
        <AddBillingInfoModal
          onGetUser={onGetUser}
          user={user}
          onGetData={onGetData}
          hideAddButton={hideAddButton}
        />
      </Box>

      {billingInfos?.length > 0 ? (
        <Box sx={styles.row}>
          <ul style={styles.list}>
            {billingInfos.map((item) => (
              <li key={item?.billingId || generateShortId()}>
                <BillingCard
                  enableEdit
                  data={item}
                  isActive={billingInfo?.billingId === item?.billingId}
                  onSelect={item?.billingId && handleSelect}
                  onEdit={(values) => handleEdit(values, item)}
                  subscription={subscription}
                />
              </li>
            ))}
          </ul>
        </Box>
      ) : (
        'No billing details found'
      )}
    </Box>
  );
};

export default BillingDetails;
